/* eslint-disable react/require-default-props */
/* eslint-disable @harmony/stencil/no-tailwind-disable */
/* eslint-disable max-len */
/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import proptypes from 'prop-types';
const { string, node } = proptypes;

/**
 * AlignedContent component is a layout component that centers its children
 * within a responsive wrapper.
 * It is designed to be used in contexts where content needs to be aligned
 * and centered, such as in a laundry bundle mini content section.
*
* @param {Object} props - The props object.
* @param {React.ReactNode} props.children - The content to be displayed inside the component.
* @param {string} [props.wrapperClassName] - Additional class names for the wrapper div.
* @param {string} [props.contentClassName] - Additional class names for the content div.
*
* @returns {JSX.Element} The rendered AlignedContent component.
*/

export const AlignedContent = ({ children, wrapperClassName = '', contentClassName = '' }) => (
  <div className={`sui-w-full sui-self-start sui-relative md:sui-pb-[calc(300%_+_3.2rem)] lg:sui-pb-[calc(200%_+_3.2rem)] ${wrapperClassName}`}>
    <div className={`md:sui-absolute sui-w-full sui-h-full sui-flex sui-justify-center sui-items-center ${contentClassName}`}>
      {children}
    </div>
  </div>
);

AlignedContent.propTypes = {
  children: node.isRequired,
  wrapperClassName: string,
  contentClassName: string
};